import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Regence Blue Cross Blue Shield",
  shortName: "Regence",
  slug: "regence-insurance",
  seoTitle:
    "Regence Blue Cross Blue Shield TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Regence Blue Cross Blue Shield policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Regence TMS coverage, Regence BCBS SPRAVATO authorization, Regence mental health benefits Coral Springs FL, Regence depression treatment Florida",
};

export const RegenceInsurance = () => <InsurancePageTemplate config={config} />;
export default RegenceInsurance;
